"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var targetTranslations = {
    'resourceEfficientEuropeanEquitiesFund': 'FR_Resource Efficient European Equities Fund',
    'Items per page:': 'Objets par page:',
    'of {totalPages}': 'sur {totalPages}',
    '{firstItem} - {lastItem} of {totalRows} items': '{firstItem} - {lastItem} éléments sur {totalRows}',
    'Page': 'Le Page',
};
var fallbackTranslations = {
    'resourceEfficientEuropeanEquitiesFund': 'EN_Resource Efficient European Equities Fund',
    'msciEurope': 'EN_MSCI Europe',
    'Items per page:': 'Objets par page:',
    "threshold_1": "threshold translated",
    'Page A': 'translated Page A',
    "xAxisLabel": "xAxisLabel Translated",
    "yAxisLabel": "yAxisLabel Translated"
};
exports.getTranslateFn = function (mustTranslate) {
    return mustTranslate ?
        exports.translate :
        function (key) { return key; };
};
exports.translate = function (key, placeholders) {
    var translation = getTranslation(key);
    return placeholders ? ksys_app_template_1.utils.replacePlaceholders({ values: placeholders, text: translation }) : translation;
};
var getTranslation = function (key) {
    return targetTranslations[key] || fallbackTranslations[key] || key;
};
